import { PrimeIcons } from "primereact/api";
import { Panel } from "primereact/panel";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { TawreedAction, TawreedActionButton, TawreedActionName } from "../../../../../../common/actions";
import { TawreedForm, TawreedFormField, TawreedFormMode, TawreedFormSubmitAction, TawreedFormSubmitProps, TawreedInputPlain } from "../../../../../../common/components/form";
import { tawreedTranslationService } from "../../../../../../common/translations";
import { Routes } from "../../../../../../router";
import { StoreProductDto, StoreProductsService, priceListDto, PriceSchemeService, priceSchemeDto } from "../../../domain";
import { PriceListServcie } from "../../../domain/services/price-list.service";
import { GlobalContext } from "../../../../../../context";
import { PartnerDto, PartnersService } from "../../../../../partners/domain";
import { AuthUtils } from "../../../../../auth/domain";
import { Toolbar } from "primereact/toolbar";
import { PriceListDetail } from "./price-list-details";
import { QuantityDialog } from "./quantity-dialog";
import {  CartService } from "../../../../../sales/cart/domain";

export const StoreProductsDetails: FC = (_props) => {
    const { id } = useParams<{ id: string | undefined }>();
    const { pid } = useParams<{ pid: string | undefined }>();

    const ref = useRef<{ submit: () => void }>();
    const [array, setArray] = useState<priceSchemeDto[]>([]);
    // let array: any[] = [];

    // di
    const service: StoreProductsService = useMemo(() => new StoreProductsService(), []);
    const cartService: CartService = React.useMemo(() => new CartService(), []);
    const priceListService: PriceListServcie = useMemo(() => new PriceListServcie(), []);
    const partnerService: PartnersService = React.useMemo(() => new PartnersService(), []);

    const priceSchemeService: PriceSchemeService = useMemo(() => new PriceSchemeService(), []);
    const { auth: { user }, constants: { constants } } = React.useContext(GlobalContext);

    const [customer, setCustomer] = React.useState<PartnerDto | undefined>(undefined);


    const [loading, setLoading] = useState<boolean>(false);
    const [mode, setMode] = React.useState<TawreedFormMode>("Create");
    const [data, setData] = useState<StoreProductDto>({
        active: true,
    });
    const [quantityState, setQuantityState] = useState({
        visible: false,
        price: 0,
        discountType: "fixed",
        discountValue: 0,
        bonusType: "",
        quantity: 0,
        priceList: 1
    });
    const [priceLists, setPriceLists] = useState<Array<priceListDto>>([]);

    const history = useHistory();
    useEffect(() => {
        let mounted = true;
        if (id) {
            if (mounted) {
                setMode("Edit");
                setLoading(true);
            }
            service
                .getDetails(Number.parseInt(id))
                .then((res) => {
                    if (mounted) {
                        setData(res);
                        user && user.roleCode !== 'CUSTOMER_ADMIN' ? setCustomer(undefined) :
                            (
                                partnerService.getDetails(user?.partnerId!)
                                    .then(res2 => {
                                        setCustomer(res2);
                                    })
                                    .catch(() => {
                                    })
                            );
                    }
                })
                .catch(() => {
                    if (mounted) {
                        setLoading(false);
                    }
                });

            priceListService.getAll().then((res) => {
                setPriceLists(res);
                var newArray: priceSchemeDto[] = [];
                res.forEach(price => {
                    priceSchemeService.getDetails(price.priceListId, Number.parseInt(id))
                        .then(res => {
                            const idx = array.findIndex((el) => el.priceListId === price.priceListId);
                            var item = {};
                            if (res.priceSchemeId) {

                                item = {
                                    ...res, price: res.price ?? data.price,
                                    priceListId: price.priceListId, storeProductId: Number.parseInt(id)
                                };
                            }
                            else {
                                item = {
                                    ...res, price: res.price ?? data.price, discountValue: 0, discountType: "fixed", bonuses: [],
                                    priceListId: price.priceListId, storeProductId: Number.parseInt(id)
                                };
                            }

                            if (idx >= 0) {
                                newArray[idx] = item;
                            }
                            else
                                newArray.push(item);

                            setLoading(false);
                            setArray([...newArray]);
                        }).catch(err => {
                            setLoading(false);
                        });
                });
            });

        }
        //setData({ ...data, store: { partnerId: user!.partnerId } })
        if (user?.roleCode === 'STORE_ADMIN')
            setData({ ...data, store: { partnerId: user.partnerId } })
        return () => {
            mounted = false;
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, service, priceListService, pid]);

    const onCustomerSelect = (customer: number) => {
        if (customer) {
            partnerService.getDetails(customer)
                .then(res => {
                    setCustomer(res);
                })
                .catch(() => {
                })

        }
    }
    const onSubmit: TawreedFormSubmitProps<StoreProductDto> = {
        showButton: false,
        resetOnSubmit: false,
        onSubmit: undefined
    };

    const onBackToCatalog = () => {
        return new Promise<void>((res, rej) => {
            history.goBack();
        });
    }
    var actions = [
        new TawreedAction(TawreedActionName.Back, "statefull", "lbl_back", PrimeIcons.ARROW_LEFT, onBackToCatalog, "p-button-outlined ml-1")
    ];
    const onSubmitExecute = (): Promise<void> => {

        return cartService.addStoreProductItem(customer?.partnerId!, data.storeProductId!, quantityState.quantity, quantityState.priceList, quantityState.bonusType)
            .then((res) => {
                if (res) {
                    let route = Routes.SalesCartsDetails.replace(':id', res.cartId);
                    route += `?priceListId=${quantityState.priceList}`;
                    route += `&&customerId=${customer?.partnerId!}`;
                    history.push(route);

                    setQuantityState({
                        visible: false,
                        price: 0,
                        discountType: "fixed",
                        discountValue: 0,
                        bonusType: "",
                        quantity: 0,
                        priceList: 1
                    })
                    return;
                }
            })
            .catch((err) => {
                setLoading(false);
            });
    }
    return (
        <React.Fragment>
            <Toolbar className="form-tawreed-toolbar"
                left={
                    <React.Fragment>
                        <span></span>
                        <h4>{data.titleEn ? (AuthUtils.current().language === 'en' ? data.titleEn : data.titleAr) : tawreedTranslationService.translate("lbl_store_product_new")}</h4>
                    </React.Fragment>
                }
                right={
                    <React.Fragment>
                        <div className="md:flex">
                            {
                                actions.map(((e, index) => <TawreedActionButton key={index} type="button" action={e} />))
                            }
                        </div>
                    </React.Fragment>
                } />
            <div>
                <React.Fragment>
                    <TawreedForm
                        customeTitle=' '
                        ref={ref}
                        title=""
                        dataKey="storeProductId" data={data} useReset submit={onSubmit}
                        loading={loading} mode={mode}
                        actions={[]}
                        className="grid form-grid">
                        <Panel header={tawreedTranslationService.translate("lbl_general_information")} className="col-12" >
                            <div className="grid">
                                <React.Fragment>
                                    <TawreedFormField name="product" title="lbl_store_products_product_id" className="field col-12 md:col-6">
                                        {
                                            <React.Fragment>
                                                <br />
                                                <span className="text-primary cursor-pointer">
                                                    {data.product?.displayName}
                                                </span>
                                            </React.Fragment>
                                        }
                                    </TawreedFormField>
                                </React.Fragment>
                                {
                                    <div className="field-tawreed field col-12 md:col-6">
                                        <label>{tawreedTranslationService.translate("lbl_product_active")}</label>
                                        <br />
                                        <span>{data.active ? tawreedTranslationService.translate("lbl_product_active") : tawreedTranslationService.translate("lbl_products_not_active")}</span>
                                    </div>

                                }
                                <TawreedFormField name="storeItemId" title="lbl_store_product_item_id" className="field col-12 md:col-6">
                                    {
                                        <TawreedInputPlain name="storeItemId" render="form" />
                                    }
                                </TawreedFormField>

                                <TawreedFormField name="expireDate" title="lbl_store_product_expire_date" className="field col-12 md:col-6">
                                    {
                                        <TawreedInputPlain name="expireDate" render="form" mode="date" />
                                    }
                                </TawreedFormField>
                                <TawreedFormField name="titleAr" title="lbl_store_product_title_ar" className="field col-12 md:col-6">
                                    {
                                        <TawreedInputPlain name="titleAr" render="form" />
                                    }
                                </TawreedFormField>
                                <TawreedFormField name="titleEn" title="lbl_store_product_title_en" className="field col-12 md:col-6">
                                    {

                                        <TawreedInputPlain name="titleEn" render="form" rules={{
                                            required: 'msg_field_is_required',
                                            validate: (value) => {
                                                var trim_value = value.trim();
                                                if (trim_value.length == 0) {
                                                    return tawreedTranslationService.translate('lbl_whiteSapce_field');
                                                }

                                            }
                                        }} />
                                    }
                                </TawreedFormField>


                                <TawreedFormField name="tax" title="lbl_store_products_tax" className="field col-12 md:col-6">
                                    {
                                        <TawreedInputPlain name="tax" render="form" mode="numeric" />
                                    }
                                </TawreedFormField>
                                <TawreedFormField name="description" title="lbl_store_product_description" className="field col-12 md:col-12">
                                    {
                                        <TawreedInputPlain name="description" render="form" />
                                    }
                                </TawreedFormField>
                            </div>

                        </Panel>
                    </TawreedForm>
                </React.Fragment>


                {
                    priceLists.map((el, idx) => {
                        return (
                            <PriceListDetail
                                name={el.priceListName!}
                                key={idx}
                                storeProductId={id ? +id : -1}
                                priceListId={el.priceListId}
                                price={data.price}
                                loading={false}
                                priceScheme={array.filter(x => x.priceListId === el.priceListId).at(0)!}
                                addToCart={() => {
                                    setQuantityState({
                                        ...quantityState,
                                        visible: true,
                                        discountType: array.filter(x => x.priceListId === el.priceListId).at(0)?.discountType!,
                                        discountValue: array.filter(x => x.priceListId === el.priceListId).at(0)?.discountValue!,
                                        price: array.filter(x => x.priceListId === el.priceListId).at(0)?.price!,
                                        priceList: el.priceListId
                                    })
                                }}
                            ></PriceListDetail>
                        )
                    })
                }
            </div>
            
            {
                <QuantityDialog
                    customer={customer}
                    onCustomerSelect={onCustomerSelect}
                    visible={quantityState.visible}
                    storeProduct={data}
                    changeQuantity={(quantity: number, bonusType: string) => {
                        setQuantityState({ ...quantityState, bonusType: bonusType, quantity: quantity })
                    }}
                    priceListId={quantityState.priceList}
                    hide={() => {
                        setQuantityState({
                            ...quantityState, visible: false,
                            bonusType: "", quantity: 0, discountType: "fixed", discountValue: 0
                        })
                    }}
                    accept={() => {
                        onSubmitExecute();
                    }}
                    discountType={quantityState.discountType}
                    discountValue={quantityState.discountValue}
                    price={quantityState.price}
                ></QuantityDialog>
            }
        </React.Fragment >
    );
};
